// @ts-check

/**
 * @typedef {(event: KeyboardEvent) => void} KeyPressHandler
 */

/**
 * @typedef {{
 *   onEnter?: KeyPressHandler,
 *   onEscape?: KeyPressHandler,
 *   onSpace?: KeyPressHandler,
 *   onTab?: KeyPressHandler,
 *   onArrowUp?: KeyPressHandler,
 *   onArrowDown?: KeyPressHandler,
 *   onArrowLeft?: KeyPressHandler,
 *   onArrowRight?: KeyPressHandler
 * } & Record<string, KeyPressHandler>} KeyPressHandlers
 */

/**
 * ?ㅻ낫???낅젰??泥섎━?섎뒗 ?대깽???몃뱾?щ? ?앹꽦?섎뒗 Composable
 * @param {KeyPressHandlers} handlers - ?ㅼ? 肄쒕갚 ?⑥닔 留?
 * @param {{ preventDefault?: boolean | string[], caseSensitive?: boolean }} [options]
 * @returns {KeyPressHandler}
 */
export function useKeyPress(handlers, options = {}) {
  const { preventDefault = false, caseSensitive = false } = options

  return (event) => {
    const { key } = event

    const keyMap = {
      Enter: 'onEnter',
      Escape: 'onEscape',
      ' ': 'onSpace',
      Tab: 'onTab',
      ArrowUp: 'onArrowUp',
      ArrowDown: 'onArrowDown',
      ArrowLeft: 'onArrowLeft',
      ArrowRight: 'onArrowRight'
    }

    const handler = (() => {
      const mappedKey = /** @type {keyof typeof keyMap} */ (key)
      if (keyMap[mappedKey]) return handlers[keyMap[mappedKey]]
      const customPressedKey = caseSensitive ? key : key.toLowerCase()
      return handlers[customPressedKey]
    })()

    if (handler) {
      const shouldPreventDefault =
        preventDefault === true || (Array.isArray(preventDefault) && preventDefault.includes(key))
      if (shouldPreventDefault) {
        event.preventDefault()
      }
    }

    if (handler) handler(event)
  }
}













